import React, { useEffect } from 'react';

import { PageMenu } from '@ui/moleculs/PageMenu';
import { PageContent } from '@ui/organisms/PageContent';
import { PageFooter } from '@ui/moleculs/PageFooter';

export const LayoutProvider: React.FC = ({ children }) => {
  useEffect(() => {
    const link = document.querySelector('link[rel*="icon"]');
    if (link !== null) {
      link.setAttribute('type', 'image/x-icon');
      link.setAttribute('rel', 'shortcut icon');
      link.setAttribute('href', 'iconDefault');
    }
  }, []);

  return (
    <div className="flex flex-col justify-content-between min-h-full">
      <PageMenu />
      <PageContent>
        {children}
      </PageContent>
      <PageFooter />
    </div>
  );
};